import { noParameters } from './parameterize';

export const createActionCreator = (type, getPayload = noParameters) => {
    if (!type) {
        return undefined;
    }
    function toString() {
        return type;
    }
    const creator = (...params) => {
        return {
            type,
            ...getPayload(...params),
        };
    };
    Object.defineProperty(creator, 'type', {
        value: type,
        writable: false,
    });
    Object.defineProperty(creator, 'toString', {
        value: toString,
        writable: false,
    });
    Object.defineProperty(creator, 'valueOf', {
        value: toString,
        writable: false,
    });
    return creator;
};

export default createActionCreator;
